import type { AssetStateTypeCreateDto, AssetStateTypeDto, AssetStateTypeUpdateDto, GetAssetStateTypesInput } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AssetStateTypeService {
  apiName = 'Inventory';

  create = (input: AssetStateTypeCreateDto) =>
    this.restService.request<any, AssetStateTypeDto>({
      method: 'POST',
      url: `/api/inventory/asset-state-types`,
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/asset-state-types/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, AssetStateTypeDto>({
      method: 'GET',
      url: `/api/inventory/asset-state-types/${id}`,
    },
    { apiName: this.apiName });

  getDefaultOption = () =>
    this.restService.request<any, AssetStateTypeDto>({
      method: 'GET',
      url: `/api/inventory/asset-state-types/default-option`,
    },
    { apiName: this.apiName });

  getList = (input: GetAssetStateTypesInput) =>
    this.restService.request<any, PagedResultDto<AssetStateTypeDto>>({
      method: 'GET',
      url: `/api/inventory/asset-state-types`,
      params: { filterText: input.filterText, name: input.name, description: input.description, code: input.code, defaultOption: input.defaultOption, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  update = (id: string, input: AssetStateTypeUpdateDto) =>
    this.restService.request<any, AssetStateTypeDto>({
      method: 'PUT',
      url: `/api/inventory/asset-state-types/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
